<template>
<div>
  <AvatarWeb :url="url" :tile="tile" :size="size" :sizeIcon="sizeIcon" :icon="icon" :updateIcon="updateIcon" v-if="deviceInfo.platform == 'web'"></AvatarWeb>
  <AvatarNatif :url="url" :tile="tile" :size="size" :sizeIcon="sizeIcon" :icon="icon" :updateIcon="updateIcon" v-else></AvatarNatif>
</div>
</template>

<script>
const AvatarNatif = () => import('@/components/camera/AvatarNatif')
const AvatarWeb = () => import('@/components/camera/AvatarWeb')

export default {
  name: 'Camera',
  computed: {
    deviceInfo: function () {
      return this.$store.getters['Device/getDevice']
    }
  },

  props: {
    'icon': {
      default: 'account_circle',
      type: String
    },
    'url': {
      default: '',
      type: String
    },
    'tile': {
      default: false,
      type: Boolean
    },
    'updateIcon': {
      default: false,
      type: Boolean
    },
    'size': {
      default: '150px',
      type: String
    },
    'sizeIcon': {
      default: '80',
      type: String
    }
  },

  components: {
    AvatarNatif,
    AvatarWeb
  }
}
</script>
